import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Checkbox,
  CheckboxGroup,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Tag,
  HStack,
  useColorModeValue,
} from "@chakra-ui/react";
import { ChevronDownIcon } from "@chakra-ui/icons";
import paymentMethodsData from "../components//data/paymentMethods.json"; // ✅ Import JSON file

const PaymentMethodsDropdown = ({ selectedMethods, onChange, onRemove }) => {
  const [paymentMethods, setPaymentMethods] = useState([]);

  // ✅ Load payment methods from JSON
  useEffect(() => {
    setPaymentMethods(paymentMethodsData.paymentMethods);
  }, []);

  return (
    <>
      <Menu>
        <MenuButton
          as={Button}
          rightIcon={<ChevronDownIcon />}
          bg={useColorModeValue("gray.50", "gray.600")}
          textAlign="left"
          width="full"
          color="brand.400"
          size={"lg"}
          fontSize={"lg"}
          _hover={{ bg: useColorModeValue("gray.100", "gray.700") }}
        >
          Select Payment Methods
        </MenuButton>
        <MenuList maxHeight="200px" overflowY="auto" width="auto" shadow="lg">
          <CheckboxGroup value={selectedMethods} onChange={onChange}>
            {paymentMethods.map(({ id, name }) => (
              <MenuItem key={id} display="flex" alignItems="center">
                <Checkbox value={id}>{name}</Checkbox>
              </MenuItem>
            ))}
          </CheckboxGroup>
        </MenuList>
      </Menu>

      {/* ✅ Display selected payment methods as tags */}
      <HStack mt={2} wrap="wrap">
        {selectedMethods.map((id) => {
          const method = paymentMethods.find((m) => m.id === id);
          return (
            <Tag key={id} colorScheme="teal" m={1} cursor="pointer" onClick={() => onRemove(id)}>
              {method ? method.name : id}
            </Tag>
          );
        })}
      </HStack>
    </>
  );
};

export default PaymentMethodsDropdown;
